<template>
	<a-dropdown v-model:open="visible" :trigger="['click']" :placement="placement">
		<!-- <a-input v-model:value="text" type="text" :size="size" :placeholder="placeholder" :loading="loading" @change="search(true)">
			<a-icon slot="prefix" type="search" />
		</a-input> -->

		<a v-if="!selected" class="text-primary" @click="visible = true">{{ text }} <a-icon type="down" /></a>
		<div v-else class="pointer d-flex flex-row align-items-center" @click="visible = true">
			<div class="mr-2">
				<a-avatar :src="images().avatar(selected)" shape="square" @error="onAvatarError">
					<template #icon>
						<a-icon type="user" />
					</template>
				</a-avatar>
			</div>
			<div class="overflow-hidden">
				<div class="text-blue text-truncate">
					{{ selected.username }}
				</div>
				<div class="text-muted">
					{{ role }}
				</div>
			</div>
		</div>

		<template #overlay>
			<div class="card air__utils__shadow" :style="{ 'width': `${width}px` }">
				<div class="card-body p-0" :style="{ 'max-height': '425px' }">
					<div :style="{ height: '425px', 'overflow-y': 'auto' }">
						<div class="p-2">
							<a-input v-model:value="input" type="text" :size="size" :placeholder="placeholder" :loading="loading" @change="search(true)">
								<template #prefix>
									<a-icon type="search" />
								</template>
							</a-input>
						</div>

						<div class="text-uppercase font-size-12 mb-2 text-gray-6 px-2 pt-2">
							<b>Resultados:</b> ({{ users.total }})
						</div>

						<template v-if="!loading">
							<ul v-if="users.results.length > 0" class="list-unstyled mb-0">
								<li v-for="u in users.results" :key="u.id" class="p-2" :class="$style.item">
									<div class="pointer d-flex flex-row align-items-center" @click="select(u)">
										<div class="mr-2">
											<a-avatar :src="images().avatar(u)" shape="square" @error="onAvatarError">
												<template #icon>
													<a-icon type="user" />
												</template>
											</a-avatar>
										</div>
										<div class="overflow-hidden">
											<div class="text-blue text-truncate">
												{{ u.username }}
											</div>
											<div class="text-muted">
												{{ auth().role(u.role) }}
											</div>
										</div>
									</div>
								</li>
							</ul>
							<ghost-message v-else class="py-4" animated="tada" infinite :icon="['fad','ghost']" :text="'Sin resultados'" />
						</template>
						<div v-else class="py-4">
							<ghost-message animated="pulse" infinite :icon="['fad','heartbeat']" :text="'Cargando'" />
						</div>
					</div>
				</div>
			</div>
		</template>
	</a-dropdown>
</template>

<script>
import _ from 'lodash';

export default {
	name: 'UserSelect',
	props: {
		value: {
			type: Number,
			default: null,
		},
		text: {
			type: String,
			default: 'Selecciona un usuario',
		},
		placeholder: {
			type: String,
			default: 'Buscar...',
		},
		size: {
			type: String,
			default: null,
		},
		placement: {
			type: String,
			default: 'bottomRight',
		},
		width: {
			type: Number,
			default: 330,
		},
	},
	emits: ['input'],
	data() {
		return {
			input: '',
			users: {
				results: [],
				total: 0,
			},
			limit: 6,
			loading: false,
			visible: false,
			selected: null,
		};
	},
	computed: {
		me() {
			return this.$store.getters.user;
		},
		role() {
			const role = this.auth().role(this.selected.role);
			if (role) return role;

			return 'Asignado';
		},
	},
	watch: {
		value(val) {
			this.setSelectedUser(val);
		},
		visible(val) {
			if (val) this.search();
		},
	},
	created() {
		if (this.value === null) {
			this.$emit('input', this.me.id);
		} else {
			this.setSelectedUser(this.value);
		}
	},
	methods: {
		onAvatarError(e) { if (e && e.target) e.target.src = require('../../../../assets/img/placeholder/avatar.jpg'); return false; },
		search: _.debounce(async function (force = false) {
			if (force || this.users.results.length === 0) {
				this.loading = true;

				const results = await this.$sdk.admin().users.list({ search: this.input, only_fake: 1, limit: this.limit });
				if (results.ok) this.users = results.data;

				this.loading = false;
			}
		}, 300),
		select(u) {
			this.$store.dispatch('addItem', { data: u, type: 'usersCache' });

			this.selected = u;
			this.visible = false;
			this.$emit('input', u.id);
		},
		async setSelectedUser(val) {
			if (val === null) val = this.me.id;

			const find = this.users.results.findIndex(u => u.id === val);

			if (find > -1) {
				this.selected = this.users.results[find];
				return;
			} if (val === this.me.id) {
				this.selected = this.me;
				return;
			} if (this.$store.getters['data/usersCache']) {
				const users = this.$store.getters['data/usersCache'].results;
				const index = users.findIndex(u => u.id === val);

				if (index > -1) {
					this.selected = {
						id: users[index].id,
						username: users[index].username,
						image_url: users[index].image_url,
					};

					return;
				}
			}

			const user = await this.$sdk.users().get(val);

			if (user.ok) {
				this.$store.dispatch('addItem', { data: user.data, type: 'usersCache' });

				this.selected = {
					id: user.data.user.id,
					username: user.data.user.username,
					image_url: user.data.user.image_url,
				};
			} else {
				this.selected = {
					id: 0,
					username: 'Desconocido',
					image_url: null,
				};
			}
		},
	},
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
